import * as Sentry from "@sentry/react";
import type { RootOptions } from "react-dom/client";

// Caught errors are already reported by the Sentry and route error boundaries.
export const reactRootOptions: RootOptions = {
    onUncaughtError: Sentry.reactErrorHandler(),
};
